import reportHandler from "../../services/Report";

export default {
    async loadDSummaries({commit}, payload) {
        return reportHandler.dSummary(payload);
    },
    async loadInvoiceByDate({commit}, payload) {
        return reportHandler.invoiceByDate(payload);
    },
    async loadSalesBySites({commit}, payload) {
        try {
            const {data} = await reportHandler.salesBySites(payload);
            commit('SET_SALES_BY_SITES', data)
        } catch (errors) {
            commit('SET_SALES_BY_SITES', [])
        }
    }
}
